import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
    width: 100%;
    background: #f8fbf6;
`;

const SectionInner = styled.div`
    width: 100%;
    max-width: 1442px;
    margin: 0 auto;
    padding: 100px 80px;
    box-sizing: border-box;

    @media (max-width: 1360px) {
        padding: 88px 56px;
    }

    @media (max-width: 1024px) {
        padding: 72px 32px;
    }

    @media (max-width: 768px) {
        padding: 56px 20px;
    }

    @media (max-width: 480px) {
        padding: 48px 16px;
    }
`;

const Frame = styled.div`
    display: flex;
    width: 100%;
    max-width: 1280px;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
`;

const TextBlock = styled.div`
    display: flex;
    width: 630px;
    max-width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Eyebrow = styled.p`
    margin: 0;
    color: #6ea44c;
    font-family: 'Montserrat', sans-serif;
    font-size: 19.2px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;
    letter-spacing: 3.84px;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 14px;
        letter-spacing: 2.8px;
        line-height: 170%;
    }
`;

const Heading = styled.h2`
    margin: 0;
    color: #003626;
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 42px;
    max-width: 630px;

    @media (max-width: 768px) {
        font-size: 24px;
        line-height: 34px;
    }
`;

const ContentRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
    width: 100%;

    @media (max-width: 1024px) {
        gap: 16px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const LargeImageCard = styled.a`
    display: block;
    width: 630px;
    height: 400px;
    border-radius: 20px;
    overflow: hidden;
    background: ${({ image }) =>
        image ? `url(${image}) lightgray 50% / cover no-repeat` : '#dfe8d9'};
    flex-shrink: 0;
    text-decoration: none;

    @media (max-width: 1280px) {
        width: calc(50% - 172.5px);
    }

    @media (max-width: 1024px) {
        width: calc(50% - 160px);
        height: 360px;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: 320px;
    }

    @media (max-width: 480px) {
        height: 260px;
        border-radius: 16px;
    }
`;

const MediumImageCard = styled.a`
    display: block;
    width: 305px;
    height: 400px;
    border-radius: 20px;
    overflow: hidden;
    background: ${({ image }) =>
        image ? `url(${image}) lightgray 50% / cover no-repeat` : '#dfe8d9'};
    flex-shrink: 0;
    text-decoration: none;

    @media (max-width: 1024px) {
        width: 260px;
        height: 360px;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: 320px;
    }

    @media (max-width: 480px) {
        height: 260px;
        border-radius: 16px;
    }
`;

const RecentActionsWrap = styled.div`
    position: relative;
    display: flex;
    width: 305px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex-shrink: 0;
    padding-bottom: 54px;

    @media (max-width: 1024px) {
        width: 260px;
    }

    @media (max-width: 768px) {
        width: 100%;
        padding-bottom: 70px;
    }
    @media (max-width: 480px) {
        width: 100%;
    }
`;

const RecentActionsTitle = styled.h3`
    margin: 0;
    width: 248px;
    max-width: 100%;
    color: #003626;
    font-family: 'Montserrat', sans-serif;
    font-size: 19.2px;
    font-style: normal;
    font-weight: 500;
    line-height: 27.2px;

    @media (max-width: 768px) {
        font-size: 18px;
        line-height: 25px;
    }
`;

const BlogCard = styled.a`
    display: flex;
    width: 305px;
    height: 112px;
    align-items: stretch;
    border-radius: 12px;
    overflow: hidden;
    background: #ffffff;
    text-decoration: none;
    box-shadow: 0 0 0 1px rgba(221, 237, 208, 0.7);

    @media (max-width: 1024px) {
        width: 260px;
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const BlogThumb = styled.div`
    width: 79.758px;
    min-width: 79.758px;
    height: 112px;
    background: ${({ image }) =>
        image ? `url(${image}) lightgray 50% / cover no-repeat` : '#dfe8d9'};

    @media (max-width: 768px) {
        width: 84px;
        min-width: 84px;
    }
`;

const BlogInfo = styled.div`
    display: flex;
    flex: 1;
    min-width: 0;
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
`;

const BlogTitle = styled.h4`
    margin: 0;
    color: #004d37;
    font-family: 'Montserrat', sans-serif;
    font-size: 19.2px;
    font-style: normal;
    font-weight: 500;
    line-height: 27.2px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media (max-width: 1024px) {
        font-size: 16px;
        line-height: 22px;
    }
`;

const ReadArticle = styled.span`
    display: inline-flex;
    width: 101px;
    min-height: 29px;
    align-items: center;
    justify-content: flex-start;
    color: #6ea44c;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
`;

const StoriesHint = styled.div`
    position: absolute;
    left: 62px;
    bottom: -41px;
    width: 128px;
    height: 58px;
    transform: rotate(-27.776deg);
    color: #6ea44c;
    text-align: center;
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 110%;
    pointer-events: none;

    @media (max-width: 1024px) {
        right: 8px;
        font-size: 20px;
    }

    @media (max-width: 768px) {
        right: 14px;
        bottom: 2px;
        font-size: 20px;
    }

    @media (max-width: 480px) {
        display: none;
    }
`;

const StoriesArrow = styled.div`
    position: absolute;
    right: 86px;
    bottom: 8px;
    width: 55px;
    height: 53px;
    transform: rotate(-10.142deg);
    pointer-events: none;

    svg {
        width: 100%;
        height: 100%;
        display: block;
    }

    @media (max-width: 1024px) {
        right: 64px;
    }

    @media (max-width: 768px) {
        right: 86px;
        bottom: 0;
    }

    @media (max-width: 480px) {
        display: none;
    }
`;

const PlaceholderBox = styled.div`
    width: 100%;
    border-radius: 20px;
    background: #edf4e8;
`;

const getArticleImage = article =>
    (article &&
        article.blog_details &&
        (article.blog_details.featuredImage ||
            article.blog_details.thumbnail ||
            article.blog_details.coverImage)) ||
    '';

const getArticleUrl = article => (article && article.slug ? `/blog/${article.slug}` : '#');

const CommunityStoriesSection = ({
    partnerName = 'Partner name',
    heading = '[Partner name] is supporting Guardians to care for their land long-term.',
    articles = [],
}) => {
    const resolvedHeading = heading.replaceAll('[Partner name]', partnerName);

    const firstLarge = articles[0] || null;
    const secondLarge = articles[1] || null;

    const recentActions =
        articles.length >= 4
            ? articles.slice(2, 4)
            : articles.length > 2
            ? articles.slice(1, 3)
            : articles.slice(0, 2);

    return (
        <SectionWrapper>
            <SectionInner>
                <Frame>
                    <TextBlock>
                        <Eyebrow>Community</Eyebrow>
                        <Heading>{resolvedHeading}</Heading>
                    </TextBlock>

                    <ContentRow>
                        {firstLarge ? (
                            <LargeImageCard
                                href={getArticleUrl(firstLarge)}
                                target="_blank"
                                rel="noreferrer"
                                image={getArticleImage(firstLarge)}
                                aria-label={firstLarge.title}
                            />
                        ) : (
                            <PlaceholderBox style={{ width: '630px', height: '400px' }} />
                        )}

                        {secondLarge ? (
                            <MediumImageCard
                                href={getArticleUrl(secondLarge)}
                                target="_blank"
                                rel="noreferrer"
                                image={getArticleImage(secondLarge)}
                                aria-label={secondLarge.title}
                            />
                        ) : (
                            <PlaceholderBox style={{ width: '305px', height: '400px' }} />
                        )}

                        <RecentActionsWrap>
                            <RecentActionsTitle>Recent actions:</RecentActionsTitle>

                            {recentActions.map(article => (
                                <BlogCard
                                    key={article.id || article.slug}
                                    href={getArticleUrl(article)}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <BlogThumb image={getArticleImage(article)} />
                                    <BlogInfo>
                                        <BlogTitle>{article.title}</BlogTitle>
                                        <ReadArticle>Read article</ReadArticle>
                                    </BlogInfo>
                                </BlogCard>
                            ))}

                            <StoriesHint>Read their stories</StoriesHint>

                            <StoriesArrow>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 38 53"
                                    fill="none"
                                >
                                    <path
                                        d="M1.08827 49.8469C0.53814 49.7982 0.0526528 50.2046 0.00390326 50.7547C-0.0448463 51.3049 0.361602 51.7904 0.911731 51.8391L1 50.843L1.08827 49.8469ZM24.2796 0.018066C23.7371 -0.0858472 23.2132 0.269634 23.1093 0.812052L21.4159 9.65131C21.312 10.1937 21.6675 10.7177 22.2099 10.8216C22.7523 10.9255 23.2763 10.57 23.3802 10.0276L24.8854 2.1705L32.7425 3.67571C33.2849 3.77962 33.8089 3.42414 33.9128 2.88172C34.0167 2.3393 33.6612 1.81534 33.1188 1.71143L24.2796 0.018066ZM1 50.843L0.911731 51.8391C6.03297 52.2929 11.973 52.162 17.5408 50.9994C23.0967 49.8393 28.377 47.6314 32.0665 43.8534C35.7945 40.036 37.8049 34.7094 36.9561 27.5546C36.1129 20.4476 32.454 11.545 24.9189 0.438771L24.0914 1.00021L23.2639 1.56164C30.7113 12.5387 34.18 21.1317 34.97 27.7902C35.7543 34.401 33.9032 39.1101 30.6356 42.4561C27.3294 45.8416 22.4798 47.9249 17.132 49.0416C11.7959 50.1558 6.05831 50.2873 1.08827 49.8469L1 50.843Z"
                                        fill="#6EA44C"
                                    />
                                </svg>
                            </StoriesArrow>
                        </RecentActionsWrap>
                    </ContentRow>
                </Frame>
            </SectionInner>
        </SectionWrapper>
    );
};

export default CommunityStoriesSection;
